import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
const getUserCredentials = userId => noPortalApiClient.get(`/api/academy-profile/v1/academy-profiles/credentials/user/${userId}`);
export const GET_USER_CREDENTIALS = registerQuery({
  fetcher: ({
    userId
  }) => getUserCredentials(userId),
  fieldName: 'credentials',
  args: ['userId']
});
export const useGetUserCredentials = userId => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_USER_CREDENTIALS, {
    variables: {
      userId
    },
    skip: !userId
  });
  return {
    data,
    loading,
    error
  };
};